module.exports = __webpack_public_path__ + "img/we.bad52e37.png";